export default function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-shape/src/descending.js
// module id = 430
// module chunks = 0 1 2 3 4